export default __webpack_public_path__ + "static/media/byod-cell.00454088.png";